import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiFetchMrdContactList = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getAllContactsForContactGroupDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      contactGroupCode: 'MRD',
      impcCode: payload.params.impcCode,
    },
  });
  return axios.get(serviceURL);
};

export const apiFetchAllContacts = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getActiveContactsDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL, payload);
};

export const apiAssociateContactToImpc = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'associateContactWithImpcDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceURL, { contactId: payload.contactId, impcCode: payload.impcCode });
};
